import React from 'react';
import MySubjects from '../components/views/MySubjects';
import SubjectCards from '../components/views/SubjectsCards';
import StudentFinder from '../components/views/StudentFinder';

// Lista statycznych zakładek
//     titleTranslationKey - Klucz translacji tytułu zakładki
//     path - adres przypisany do zakładki np, "adres-przykladowej-zakladki"
//     component - Komponent, który zostanie wyrenderowany w ciele zakładki
//     accessName - nazwa klucza dostępu do danej zakładki
//     key - klucz zakładki, numerowany od zera dla każdej kolejnej zakładki, w formacie string

export const staticTabsList: StaticTab[] = [
  {
    titleTranslationKey: 'MY_SUBJECTS_TAB_TITLE',
    path: '/moje-przedmioty',
    component: MySubjects as React.ComponentType<StaticViewComponent>,
    accessName: 'tab-moje-przedmioty',
    view: 'MySubjects' as const,
    key: '0',
  },
  {
    titleTranslationKey: 'STUDENT_FINDER_TAB_TITLE',
    path: '/studenci',
    component: StudentFinder as React.ComponentType<StaticViewComponent>,
    accessName: 'tab-studenci',
    view: 'StudentFinder' as const,
    key: '1',
  },
  {
    titleTranslationKey: 'SUBJECT_CARDS_TAB_TITLE',
    path: '/karty-przedmiotów',
    component: SubjectCards as React.ComponentType<StaticViewComponent>,
    accessName: 'tab-karty-przedmiotow',
    view: 'SubjectsCards' as const,
    key: '2',
  },
];
